import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromShared from './../../shared/state/reducers';
import * as titleActions from './../../shared/state/actions/title.action';

@Component({
  selector: 'ats-un-authorized-access',
  templateUrl: './un-authorized-access.component.html',
  styleUrls: ['./un-authorized-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnAuthorizedAccessComponent implements OnInit {

  constructor(private sharedStore: Store<fromShared.State>) { }
  pageTitle = 'Unauthorized';

  ngOnInit(): void {
    this.sharedStore.dispatch(titleActions.SetTitle({ title: this.pageTitle }));
  }

}
